import { css } from '@emotion/core'
import { spacing, measures, colors, font } from 'styles/variables'

const { unit } = measures

export default {
  formListItem: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-decoration: none;
    width: 100%;
    padding: ${spacing(2.5)};
    background-color: ${colors.grays.gray8};
    color: ${colors.white100};
    border-radius: ${unit * 1.5}px;
    box-sizing: border-box;
    transition: all 0.3s ease;
    font-family: ${font.family};
    :hover {
      background-color: ${colors.grays.gray7};
    }
    cursor: pointer;
    display: flex;
    margin-bottom: ${spacing(1)};
  `,
  carret: css`
    padding: ${spacing(0.5)};
    color: ${colors.white100};
  `,
}
